import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3013983402/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>
  Registry Operator Terms and Conditions Applicable to all .BIZ Registrations
    </h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>I. REGISTRATION RESTRICTIONS </strong>
    </p>
    <p>
  <strong>1.</strong> You hereby represent and warrant that:{' '}
    </p>
    <blockquote>
  <p>
    a) The registered domain name will be used primarily for bona fide business
    or commercial purposes and not (i) exclusively for personal use; or (ii)
    solely for the purposes of (1) selling, trading or leasing the domain name
    for compensation, or (2) the unsolicited offering to sell, trade or lease
    the domain name for compensation.
  </p>
  <p>b) You have the authority to enter into the registration agreement; and</p>
  <p>
    c) The registered domain name is reasonably related to your business or
    intended commercial purpose at the time of registration.
  </p>
    </blockquote>
    <p>
  <strong>2.</strong> For the purposes of the .biz Registration Restrictions,
  “bona fide business or commercial use” shall mean the bona fide use of bona
  fide intent to use the domain name or any content, software, materials,
  graphics or other information thereon, the permit Internet users to access one
  or more host computers through the DNS:{' '}
    </p>
    <blockquote>
  <p>1. To exchange goods, services, or property of any kind; </p>
  <p>2. In the opportunity course of trade or business; or </p>
  <p>
    3. To facilitate (i) the exchange of goods, services, information, or
    property of any kind; or, (ii) the ordinary course of trade or
    business.{' '}
  </p>
    </blockquote>
    <p>
  <strong>3.</strong> Registering a domain name solely for the purpose of (1)
  selling, trading or leasing the domain name for compensation, or (2) the
  unsolicited offering to sell, trade or lease the domain name for compensation
  shall not constitute a “bona fide business or commercial use” of that domain
  name.{' '}
    </p>
    <p>
  <strong>4.</strong> For illustration purposes, the following shall not
  constitute a “bona fide business or commercial use” of a domain name:{' '}
    </p>
    <blockquote>
  <p>
    1. Using or intending to use the domain name exclusively for personal,
    noncommercial purposes; or{' '}
  </p>
  <p>
    2. Using or intending to use the domain name exclusively for the expression
    of noncommercial ideas (i.e., registering abcsucks.biz exclusively to
    criticize or otherwise express an opinion on the products or services of ABC
    company, with no other intended business or commercial purpose); or{' '}
  </p>
  <p>
    3. Using the domain name for the submission of unsolicited bulk e-mail,
    phishing, pharming or other abusive or fraudulent purposes{' '}
  </p>
    </blockquote>
    <p>
  <strong>II. DISPUTE RESOLUTION </strong>
    </p>
    <p>
  <strong>1.</strong> You acknowledge having read and understood and agree to be
  bound by the terms and conditions of the following documents, as they may be
  amended from time to time, which are hereby incorporated and made an integral
  part of this Agreement:{' '}
    </p>
    <blockquote>
  <p>
    (i) The Uniform Domain Name Dispute Resolution Policy, currently available
    at{' '}
    <a href="http://www.icann.org/udrp/udrp/htm">
      http://www.icann.org/udrp/udrp/htm
    </a>
    ; and{' '}
  </p>
  <p>
    (ii) The Restrictions Dispute Resolution Criteria and Rules, currently
    available at{' '}
    <a href="http://www.neustar-registry.biz/?q=node/51">
      http://www.neustar-registry.biz/?q=node/51
    </a>
    .{' '}
  </p>
    </blockquote>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      